import {
  VariationsProductDetailsRecord,
  VariationsDetailGridMetricType
} from 'src/components/BeaconV2Components/ExperimentalLayout/ContentV3/ContentServerProxy/types';
import { GetEntityMetadataResponseRecord } from 'src/components/BeaconV2Components/ExperimentalLayout/ContentV3/helpers/contentVariationUtils';
import { ChartDataAdapter } from './types';
import {
  StandardTableRecord,
  filterRecordsByMetricType,
  buildPeriodMap,
  transformRecord
} from './VariationsProductDetailGridAdapterUtils';

export class VariationsProductDetailGridAdapter implements ChartDataAdapter<StandardTableRecord[]> {
  constructor(
    private currentPeriodRecords: VariationsProductDetailsRecord[],
    private periodRecords: VariationsProductDetailsRecord[],
    private selectedDropdownFilterType: VariationsDetailGridMetricType,
    private productMetadataMap: Map<string, GetEntityMetadataResponseRecord>
  ) {}

  transform(): StandardTableRecord[] {
    const filteredCurrentPeriodRecords = filterRecordsByMetricType(
      this.currentPeriodRecords,
      this.selectedDropdownFilterType
    );
    const periodMap = buildPeriodMap(this.periodRecords, this.selectedDropdownFilterType);

    return filteredCurrentPeriodRecords.map((record) => transformRecord(record, periodMap, this.productMetadataMap));
  }
}

export type { GetEntityMetadataResponseRecord, StandardTableRecord };
